<template>
    <svg v-if="hasData" :width="w" :height="h" class="c-sparkline" :style="rootStyle">
        <path :d="areaPath" :fill="color" opacity="0.08" />
        <path :d="linePath" fill="none" :stroke="color" stroke-width="1.4" />
        <circle
            v-for="(p, i) in points"
            :key="i"
            :cx="p[0]"
            :cy="p[1]"
            :r="i === points.length - 1 ? 2.5 : 1.5"
            :fill="i === points.length - 1 ? color : '#fff'"
            :stroke="color"
            stroke-width="1"
        />
    </svg>
</template>

<script>
import { TAG_RED } from './tokens';

export default {
    name: 'Sparkline',
    props: {
        // [{ p, inv, col, com }, ...] — only `col` (collected) is plotted.
        // Shape matches the prototype's mock history and the wizard's real
        // sale-history records.
        history: { type: Array, default: () => [] },
        height: { type: Number, default: 36 },
        color: { type: String, default: TAG_RED },
    },
    computed: {
        hasData() {
            return Array.isArray(this.history) && this.history.length > 0;
        },
        w() { return 140; },
        h() { return this.height; },
        vals() {
            return this.history.map((entry) => entry.col || 0);
        },
        max() {
            return Math.max(...this.vals, 1);
        },
        points() {
            const step = this.w / (this.vals.length - 1 || 1);
            return this.vals.map((v, i) => [
                i * step,
                this.h - (v / this.max) * (this.h - 4) - 2,
            ]);
        },
        linePath() {
            return this.points
                .map((p, i) => `${i ? 'L' : 'M'}${p[0].toFixed(1)},${p[1].toFixed(1)}`)
                .join(' ');
        },
        areaPath() {
            return `${this.linePath} L${this.w},${this.h} L0,${this.h} Z`;
        },
        rootStyle() {
            return { display: 'block' };
        },
    },
};
</script>
